import React, { useEffect, useRef } from 'react';
import "./videoAbsolute.scss";
import thumbnail from '../../images/video-tumbnail.webp';

const VideoAbs = (props) => {
    const videoRef = useRef(null);
    const playCount = useRef(0);

    useEffect(() => {
        const video = videoRef.current;
        video.playbackRate = 1.09;

        const handleEnded = () => {
            playCount.current += 1;

            if (playCount.current >= 4) {
                video.pause();
            } else {
                video.play();
                
            }
        };

        video.addEventListener('ended', handleEnded);

        return () => {
            video.removeEventListener('ended', handleEnded);
        };
    }, []);

    return (
        <div className="video-abs__wrapper">
            <img
                loading="eager"
                src={thumbnail}
                className="banner-thumbnail"
                style={{ opacity: 0 }}
                alt={props.thumbnailAlt}
            />
            <video ref={videoRef} autoPlay muted playsInline>
                <source src={props.videoSrc} type="video/mp4" />
            </video>
        </div>
    );
};

export default VideoAbs;